import React, { FunctionComponent, ReactElement, useMemo, memo, useEffect } from 'react'
import times from 'lodash/times'
import Grid from '@sport1/react-elements/Grid'
import { LayoutItemSize, Spacing } from '../../LayoutTypes'
import { getWidthProps, spaceMap } from '../../LayoutUtils'
import { BackgroundColorTypes } from '../../../Theme/Fonts/FontTypes'
import { TestID } from '../../../utils/PropTypesDefinitions'
import { logComponentDeprecation } from '../../../utils/Deprecation'

type MultiColumnLayoutProps = {
    spaceBottom?: Spacing
    spaceX?: Spacing
    numberOfColumns: number
    renderColumn: (index: number) => ReactElement | ReactElement[] | null
    columnWidths?: LayoutItemSize[]
    backgroundColor?: BackgroundColorTypes
    children?: never
    center?: boolean
} & TestID

const MultiColumnLayout: FunctionComponent<MultiColumnLayoutProps> = ({
    spaceX,
    spaceBottom,
    numberOfColumns,
    renderColumn,
    columnWidths = [],
    backgroundColor = 'tahitian-4',
    center,
    testID,
}): ReactElement => {
    /* istanbul ignore next */
    useEffect(() => {
        logComponentDeprecation('MultiColumnLayout')
    }, [])

    const columns = useMemo(() => {
        const tmpColumns: ReactElement[] = []
        times(numberOfColumns, (i): void => {
            tmpColumns.push(
                <Grid
                    key={`column_${i}`}
                    centerVertical={center}
                    overflow="hidden"
                    {...getWidthProps(columnWidths[i])}
                >
                    {renderColumn(i)}
                </Grid>
            )
        })
        return tmpColumns
    }, [center, columnWidths, numberOfColumns, renderColumn])

    return (
        <Grid
            noExpand
            horizontal
            paddingX={spaceMap.get(spaceX)}
            paddingBottom={spaceMap.get(spaceBottom)}
            backgroundColor={backgroundColor}
            testID={testID}
        >
            {columns}
        </Grid>
    )
}

export default memo(MultiColumnLayout)
